import { render, staticRenderFns } from "./TypeOrigin.vue?vue&type=template&id=1d8094ef&"
import script from "./TypeOrigin.vue?vue&type=script&lang=js&"
export * from "./TypeOrigin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports